<script setup lang="ts">
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import type { OzMenuRowsRow } from '@@/library/v4/components/OzMenuRows.vue'
import OzMenuRows, {
  OzMenuRowsFocusStyle,
  OzMenuRowsRowRole,
  OzMenuRowsSizePreset,
} from '@@/library/v4/components/OzMenuRows.vue'
import type { VueCssClass } from '@@/types'

withDefaults(
  defineProps<{
    rows: OzMenuRowsRow[]
    menuAriaLabel: string
    rowCommonSettings?: OzMenuRowsRow
    darkMode?: boolean | 'auto'
    sizePreset?: OzMenuRowsSizePreset
    containerClass?: VueCssClass
    testId?: string
  }>(),
  {
    rowCommonSettings: () => ({
      role: OzMenuRowsRowRole.MenuItemRadio,
      iconSize: 20,
    }),
    darkMode: 'auto',
    sizePreset: OzMenuRowsSizePreset.H56px,
    containerClass: undefined,
    testId: undefined,
  },
)

defineEmits<{
  (e: 'select-row', event: Event, payload: any): void
}>()
</script>
<script lang="ts">
export {
  OzMenuRowsFocusStyle as OzDropdownFocusStyle,
  OzMenuRowsRowStyle as OzDropdownRowStyle,
  OzMenuRowsSizePreset as OzDropdownSizePreset,
} from '@@/library/v4/components/OzMenuRows.vue'
export type { OzMenuRowsRow as OzDropdownRow } from '@@/library/v4/components/OzMenuRows.vue'
export default {}
</script>

<template>
  <div class="rounded-2.5xl overflow-hidden">
    <OzBox
      :color="OzBoxColors.Primary"
      :dark-mode="darkMode"
      :class="[
        'flex flex-col',
        'h-full w-full',
        'overflow-auto',
        'py-1',
        {
          'scrollbar-thin-dark': darkMode === true,
          'scrollbar-thin': darkMode === false,
          'scrollbar-thin dark:scrollbar-thin-dark': darkMode === 'auto',
        },
        containerClass,
      ]"
    >
      <slot name="top-content"></slot>
      <OzMenuRows
        :accessibility-role="'menu'"
        :aria-label="menuAriaLabel"
        :dark-mode="darkMode"
        :size-preset="sizePreset"
        :common-settings="rowCommonSettings"
        :focus-style="OzMenuRowsFocusStyle.Grey100"
        :x-last-row-divider="false"
        :rows="rows"
        :data-testid="testId"
        @select-row="(event, payload) => $emit('select-row', event, payload)"
      />
      <slot name="bottom-content"></slot>
    </OzBox>
  </div>
</template>
